/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MyTournamentEntryResponse } from './MyTournamentEntryResponse';
import {
    MyTournamentEntryResponseFromJSON,
    MyTournamentEntryResponseFromJSONTyped,
    MyTournamentEntryResponseToJSON,
    MyTournamentEntryResponseToJSONTyped,
} from './MyTournamentEntryResponse';
import type { TournamentInvitationEntryResponse } from './TournamentInvitationEntryResponse';
import {
    TournamentInvitationEntryResponseFromJSON,
    TournamentInvitationEntryResponseFromJSONTyped,
    TournamentInvitationEntryResponseToJSON,
    TournamentInvitationEntryResponseToJSONTyped,
} from './TournamentInvitationEntryResponse';

/**
 * User's tournaments grouped by status
 * @export
 * @interface MyTournamentsResponse
 */
export interface MyTournamentsResponse {
    /**
     * Active tournaments (registration, ready, in progress)
     * @type {Array<MyTournamentEntryResponse>}
     * @memberof MyTournamentsResponse
     */
    active: Array<MyTournamentEntryResponse>;
    /**
     * Past tournaments (completed, cancelled)
     * @type {Array<MyTournamentEntryResponse>}
     * @memberof MyTournamentsResponse
     */
    past: Array<MyTournamentEntryResponse>;
    /**
     * Pending team invitations
     * @type {Array<TournamentInvitationEntryResponse>}
     * @memberof MyTournamentsResponse
     */
    invitations: Array<TournamentInvitationEntryResponse>;
}

/**
 * Check if a given object implements the MyTournamentsResponse interface.
 */
export function instanceOfMyTournamentsResponse(value: object): value is MyTournamentsResponse {
    if (!('active' in value) || value['active'] === undefined) return false;
    if (!('past' in value) || value['past'] === undefined) return false;
    if (!('invitations' in value) || value['invitations'] === undefined) return false;
    return true;
}

export function MyTournamentsResponseFromJSON(json: any): MyTournamentsResponse {
    return MyTournamentsResponseFromJSONTyped(json, false);
}

export function MyTournamentsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MyTournamentsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'active': ((json['active'] as Array<any>).map(MyTournamentEntryResponseFromJSON)),
        'past': ((json['past'] as Array<any>).map(MyTournamentEntryResponseFromJSON)),
        'invitations': ((json['invitations'] as Array<any>).map(TournamentInvitationEntryResponseFromJSON)),
    };
}

export function MyTournamentsResponseToJSON(json: any): MyTournamentsResponse {
    return MyTournamentsResponseToJSONTyped(json, false);
}

export function MyTournamentsResponseToJSONTyped(value?: MyTournamentsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'active': ((value['active'] as Array<any>).map(MyTournamentEntryResponseToJSON)),
        'past': ((value['past'] as Array<any>).map(MyTournamentEntryResponseToJSON)),
        'invitations': ((value['invitations'] as Array<any>).map(TournamentInvitationEntryResponseToJSON)),
    };
}

